import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';

const ColumnChartReceberVencimento = ({ rawData }) => {
  const daysArray = [];
  const pagoData = [];
  const temperatureData = [];

  rawData.forEach((data) => {
    daysArray.push(`${data.day}`);
    pagoData.push(data.payments_value);
    temperatureData.push(data.payments_paid_value);
  });

  const series = [
     {
       name: 'Valor à ser recebido',
       type: 'bar',
       data: temperatureData,
       itemStyle: {
         color: 'rgba(21, 171, 81, 1)',
         padding: [1, 1],
         borderRadius: [10, 10, 0, 0],
       },
       label: {
         show: true,
         rotate: 90,             
         position: 'top',
         offset: [16, 8],
         padding: [1, 1],
         borderRadius: [10, 10, 0, 0],
         formatter: (params) => formatLargeNumber(Number(params.value)),
       },
     },
     {
       name: 'Valor real recebido',
       type: 'bar',
       data: pagoData,
       itemStyle: {
         borderRadius: [10, 10, 0, 0],
         color: (params) =>
           rawData[params.dataIndex].above_value
             ? 'rgba(21, 171, 81, 1)'
             : 'rgba(224, 74, 76, 1)',
       },
       label: {
         show: true,
          rotate: 90,     
         offset: [16, 8],
         position: 'top',
         padding: [1, 1],
         borderRadius: [10, 10, 0, 0],
         formatter: (params) => formatLargeNumber(Number(params.value)),
       },
     },
  ];


  const option = {
    title: {
      text: 'Contas a receber por data de vencimento',
      textStyle: {
        fontSize: '14px',
      },
      left: '0%',
      top: '0%',
    },
    legend: {
      data: [
        { name: 'Valor real recebido', icon: 'circle', itemStyle: { color: '#15AB51' } },
        { name: 'Valor à ser recebido', icon: 'circle', itemStyle: { color: '#E04A4C' } },
      ],
      right: '0%',
      top: '5%',
      orient: 'horizontal',
      formatter: function (name) {
        return name;
      },
      textStyle: {
        rich: {
          redDot: {
            color: '#E04A4C',
            fontSize: 30,
            padding: [0, 5],
          },
          blueDot: {
            color: '#15AB51',
            fontSize: 30,
            padding: [0, 5],
          },
        },
      },
    },
    grid: {
      top: '20%',
      bottom: '20%',
      left: '5%',
      right: '5%',
    },
    yAxis: [
      {
        type: 'value',
        name: '',
        nameTextStyle: {
          fontSize: 14,
          color: '#333',
        },
        axisLabel: {
          formatter: (value) => formatLargeNumber(value),
        },
        splitLine: {
          show: true,
        },
      },
      {
        type: 'value',
        axisLabel: {
          formatter: '',
        },
      },
    ],
    xAxis: [
      {
        type: 'category',
        data: daysArray,
        axisLabel: {
          formatter: (value) => value,
        },
      },
    ],
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const day = params[0].name;
        const pagoValue = params[0].value;
        const temperatureValue = params[1].value;
        const inadimplencia = temperatureValue
          ? ((pagoValue / temperatureValue) * 100).toFixed(2)
          : '0.00';
        const diferenca = temperatureValue - pagoValue;
        const inadimplenciaPercent = temperatureValue
          ? ((diferenca / temperatureValue) * 100).toFixed(2)
          : '0.00';
        return `
          <div>
            <strong>dia ${day}</strong><br />
            Valor a receber: ${formatLargeNumber(Number(temperatureValue.toFixed(2)))}<br />
            Valor recebido: ${formatLargeNumber(Number(pagoValue.toFixed(2)))}<br />
            Diferença: ${formatLargeNumber(Number(diferenca.toFixed(2)))}<br />
            <b>Inadimplência: ${inadimplenciaPercent}%</b><br />
          </div>
        `;
      },
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'} p={2}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartReceberVencimento;
